export default __webpack_public_path__ + "static/media/Minor Brew of Acute Striking.f7059679.jpg";